import React, { useMemo } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { formatPageItemsRange } from '../utils/common';

const TablePagination = ({
  selectedItemsCount,
  total,
  currentPage,
  pageSize
}) => {
  const fromCount = useMemo(
    () => (currentPage - 1) * pageSize + 1,
    [currentPage, pageSize]
  );

  const toCount = useMemo(() => {
    const currentPageCount = currentPage * pageSize;

    return currentPageCount > total ? total : currentPageCount;
  }, [currentPage, total, pageSize]);

  return (
    <Container>
      <div>{selectedItemsCount > 0 && `${selectedItemsCount} Selected`}</div>
      <div>{formatPageItemsRange({ total, fromCount, toCount })}</div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

TablePagination.propTypes = {
  selectedItemsCount: PropTypes.number,
  total: PropTypes.number.isRequired,
  currentPage: PropTypes.number,
  pageSize: PropTypes.number
};

export default TablePagination;
